import {
    DescriptionOutlined,
    EventRepeatOutlined,
    FactCheckOutlined,
    GroupsOutlined,
} from '@mui/icons-material';
import { Box, CircularProgress, Stack, Typography } from '@mui/material';
import React from 'react';
import { getMetrics } from '../../../../services/patients/patientsV2Service';

interface MetricsResponse {
    inProgram: number;
    requested: number;
    pending: number;
    inAnalysis: number;
}

export const KPICards: React.FC = () => {
    const [loading, setLoading] = React.useState(true)
    const [metrics, setMetrics] = React.useState({
        inProgram: 0,
        requested: 0,
        pending: 0,
        inAnalysis: 0
    });

    React.useEffect(() => {
        try {
            const timeout = window.setTimeout(async () => {
                const getMetricsResponse = await getMetrics();

                setMetrics(getMetricsResponse);
            })

            return () => window.clearTimeout(timeout);
        } catch (error) {
            console.log("Erro ao consultar as métricas Paciente V2");
            setMetrics({
                inProgram: 0,
                requested: 0,
                pending: 0,
                inAnalysis: 0
            })
        } finally {
            setLoading(false)
        }
    }, []);

    return (
        <Stack direction="row" useFlexGap flexWrap="wrap" spacing={1.5} sx={{ mb: 2.5 }}>
            <Box
                sx={{
                    flex: '1 1 210px',
                    minWidth: { xs: '100%', sm: 210 },
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1.5,
                    p: 2,
                    borderRadius: 2,
                    backgroundColor: 'white',
                    border: '1px solid #e8e8e8',
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
                }}
            >
                <Box
                    sx={{
                        width: 44,
                        height: 44,
                        minWidth: 44,
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: "#318300",
                        backgroundColor: "#eef7e9",
                    }}
                >
                    <GroupsOutlined />
                </Box>
                <Box>
                    <Typography variant="body2" color="text.secondary">
                        No programa
                    </Typography>
                    <Typography variant="h5" sx={{ color: "#318300", fontWeight: 700, lineHeight: 1.2, textAlign: "center" }}>
                        {loading ? <CircularProgress size={16} /> : metrics.inProgram}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                        Dados não disponíveis
                    </Typography>
                </Box>
            </Box>
            <Box
                sx={{
                    flex: '1 1 210px',
                    minWidth: { xs: '100%', sm: 210 },
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1.5,
                    p: 2,
                    borderRadius: 2,
                    backgroundColor: 'white',
                    border: '1px solid #e8e8e8',
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
                }}
            >
                <Box
                    sx={{
                        width: 44,
                        height: 44,
                        minWidth: 44,
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: "#1769aa",
                        backgroundColor: "#edf5fc",
                    }}
                >
                    <FactCheckOutlined />
                </Box>
                <Box>
                    <Typography variant="body2" color="text.secondary">
                        Solicitações em análise
                    </Typography>
                    <Typography variant="h5" sx={{ color: "#1769aa", fontWeight: 700, lineHeight: 1.2, textAlign: "center" }}>
                        {loading ? <CircularProgress size={16} style={{ textAlign: "center" }} /> : metrics.inAnalysis}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                        Dados não disponíveis
                    </Typography>
                </Box>
            </Box>
            <Box
                sx={{
                    flex: '1 1 210px',
                    minWidth: { xs: '100%', sm: 210 },
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1.5,
                    p: 2,
                    borderRadius: 2,
                    backgroundColor: 'white',
                    border: '1px solid #e8e8e8',
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
                }}
            >
                <Box
                    sx={{
                        width: 44,
                        height: 44,
                        minWidth: 44,
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: "#b76e00",
                        backgroundColor: "#fff7e8",
                    }}
                >
                    <DescriptionOutlined />
                </Box>
                <Box>
                    <Typography variant="body2" color="text.secondary">
                        Documentos pendentes
                    </Typography>
                    <Typography variant="h5" sx={{ color: "#b76e00", fontWeight: 700, lineHeight: 1.2, textAlign: "center" }}>
                        {loading ? <CircularProgress size={16} /> : metrics.pending}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                        Dados não disponíveis
                    </Typography>
                </Box>
            </Box>
            <Box
                sx={{
                    flex: '1 1 210px',
                    minWidth: { xs: '100%', sm: 210 },
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1.5,
                    p: 2,
                    borderRadius: 2,
                    backgroundColor: 'white',
                    border: '1px solid #e8e8e8',
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
                }}
            >
                <Box
                    sx={{
                        width: 44,
                        height: 44,
                        minWidth: 44,
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: "#7b3f98",
                        backgroundColor: "#f7effa",
                    }}
                >
                    <EventRepeatOutlined />
                </Box>
                <Box>
                    <Typography variant="body2" color="text.secondary">
                        Reavaliações pendentes
                    </Typography>
                    <Typography variant="h5" sx={{ color: "#7b3f98", fontWeight: 700, lineHeight: 1.2, textAlign: "center" }}>
                        {loading ? <CircularProgress size={16} /> : metrics.requested}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                        Dados não disponíveis
                    </Typography>
                </Box>
            </Box>
        </Stack>
    );
};

<Stack direction="row" useFlexGap flexWrap="wrap" spacing={1.5} sx={{ mb: 2.5 }}>

</Stack>
